// extracted by mini-css-extract-plugin
export default {"Origins":"Origins_Origins__cdPG4","OriginsList":"Origins_OriginsList__KM3uk","OriginsHeader":"Origins_OriginsHeader__S2f78"};